import type { ReactNode } from 'react';
import React, { createContext, useMemo } from 'react';
import { type TaskStateT } from '../../types/types';
import type { TaskStateStoreT } from '../types';
import { getDefaultTaskStateStore, getTaskStateStore } from '../utils';
export const TaskStateStoreContext = createContext<TaskStateStoreT>(getDefaultTaskStateStore());
type PropsT = {
  taskState: TaskStateT;
  children: ReactNode;
};
export const TaskStateProvider = ({
  taskState,
  children
}: PropsT) => {
  // eslint-disable-next-line react-hooks/preserve-manual-memoization
  const taskStateStore = useMemo(() => getTaskStateStore(taskState), []);
  return <TaskStateStoreContext.Provider value={taskStateStore}>
      {children}
    </TaskStateStoreContext.Provider>;
};